import { useUserStore } from '@/stores/modules/user'

/**
 * 监听app事件
 */
export function useAppEvent() {
  if (window.electron) {
    // App退出
    window.electron.onAppExit?.(() => {
      const userStore = useUserStore()
      userStore.logout()
    })
  }
}
